<template>
  <div class="login-wrapper">
    <div class="login-bg"></div>
    <v-row justify="center" align="center" style="min-height: 100vh; position: relative; z-index: 1">
      <v-col cols="11" sm="8" md="5" lg="4" xl="3">
        <div class="text-center mb-8">
          <div class="logo-circle mx-auto mb-4">
            <v-icon x-large dark>mdi-label-multiple</v-icon>
          </div>
          <h1 class="text-h4 font-weight-bold white--text">Labelbase</h1>
          <p class="text-body-2 grey--text text--lighten-1 mt-1">Device Label Management</p>
        </div>
        <v-card class="login-card elevation-0">
          <v-card-text class="pa-8">
            <v-form ref="form" @submit.prevent="login">
              <div class="text-subtitle-1 font-weight-medium mb-6" :class="$vuetify.theme.dark ? 'white--text' : ''">
                Sign in to your account
              </div>
              <v-text-field
                v-model="username"
                label="Username"
                prepend-inner-icon="mdi-account-outline"
                outlined
                rounded
                :rules="[function(v) { return !!v || 'Required' }]"
                class="mb-2"
              />
              <v-text-field
                v-model="password"
                label="Password"
                prepend-inner-icon="mdi-lock-outline"
                type="password"
                outlined
                rounded
                :rules="[function(v) { return !!v || 'Required' }]"
                @keyup.enter="login"
              />
              <v-alert v-if="error" type="error" dense rounded="lg" class="mb-4">{{ error }}</v-alert>
              <v-btn
                color="primary"
                block
                x-large
                rounded
                :loading="loading"
                @click="login"
                class="mt-2 login-btn"
              >
                Sign In
              </v-btn>
            </v-form>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import api from '../api';

export default {
  name: 'Login',
  data: function () {
    return {
      username: '',
      password: '',
      loading: false,
      error: null,
    };
  },
  methods: {
    login: function () {
      if (!this.$refs.form.validate()) return;
      var self = this;
      self.loading = true;
      self.error = null;
      api
        .post('/auth/login', {
          username: self.username,
          password: self.password,
        })
        .then(function (res) {
          self.$store.commit('setAuth', {
            token: res.data.access_token,
            username: self.username,
          });
          self.$store.dispatch('fetchProducts');
          self.$router.push('/');
        })
        .catch(function (err) {
          self.error = (err.response && err.response.data && err.response.data.detail) || 'Login failed';
        })
        .finally(function () {
          self.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.login-wrapper {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  overflow: auto;
}
.login-bg {
  position: fixed;
  top: 0; left: 0; right: 0; bottom: 0;
  background: linear-gradient(135deg, #0F0C29 0%, #1A1A2E 40%, #302B63 100%);
}
.logo-circle {
  width: 72px;
  height: 72px;
  border-radius: 20px;
  background: linear-gradient(135deg, #6C63FF 0%, #A78BFA 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 8px 32px rgba(108, 99, 255, 0.4);
}
.login-card {
  backdrop-filter: blur(20px);
  background: rgba(22, 33, 62, 0.7) !important;
  border: 1px solid rgba(108, 99, 255, 0.2) !important;
}
.login-btn {
  text-transform: none !important;
  font-weight: 600 !important;
  font-size: 16px !important;
  letter-spacing: 0 !important;
  background: linear-gradient(135deg, #6C63FF 0%, #A78BFA 100%) !important;
}
</style>
